import React, { useState } from 'react'
import styled from 'styled-components'
import { MarkDownText } from './Text'

// Components
import { Tabs, Tab } from './Tabs'

export interface ITab {
  tag?: string
  richText: string
  openByDefault?: boolean
}

interface IProps {
  tabs: ITab[]
  className?: string
  updateTab?: (index: number, e?: any) => void
  textColor?: string
  tabColor?: string
  defaultTabColor?: string
}

const TabsWithContent: React.FC<IProps> = ({
  tabs,
  className,
  updateTab,
  textColor,
  tabColor,
  defaultTabColor,
}) => {
  const [activeTab, setActiveTab] = useState<number>(
    Math.max(
      0,
      tabs.findIndex((tab) => tab.openByDefault)
    )
  )

  return (
    <Container className={className}>
      <Tabs>
        {tabs.map((tab, i) => {
          if (tab.tag) {
            return (
              <Tab
                key={`tab-tag-${i}`}
                label={tab.tag}
                onClick={(e) => {
                  setActiveTab(i)
                  if (updateTab) updateTab(i, e)
                }}
                selected={activeTab === i}
                tabColor={tabColor}
                textColor={textColor}
                defaultTabColor={defaultTabColor}
              />
            )
          }
        })}
      </Tabs>
      {tabs.map((tab, i) => (
        <Content
          key={`tab-content-${i}`}
          textStyle="bodySmall"
          selected={activeTab === i}
          textColor={textColor}
        >
          {tab.richText}
        </Content>
      ))}
    </Container>
  )
}

const Container = styled.div`
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.primaryLight};
  border-radius: 12px;
`

const Content = styled(MarkDownText)<{ selected: boolean; textColor?: string }>`
  display: ${({ selected }) => (selected ? 'block' : 'none')};
  margin-top: 4px;
  color: ${({ theme, textColor }) =>
    textColor ? textColor : theme.colors.textLight};
`

export default TabsWithContent
